module.exports = __webpack_public_path__ + "img/keegan_thumb.3f623288.jpg";